import React from 'react'
import { Box, Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

export const DiscoPromoContentSkeletonLoader = () => {
  return (
    <Box p={3}>
      <Skeleton
        variant="text"
        width={200}
        height={35}
        style={{ marginBottom: 12 }}
      />

      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="text" width="50%" height={20} />
      <Skeleton
        variant="text"
        width="20%"
        height={20}
        style={{ marginBottom: 20 }}
      />

      <Skeleton
        variant="text"
        width={180}
        height={28}
        style={{ marginBottom: 15 }}
      />

      <Skeleton
        variant="text"
        width={120}
        height={18}
        style={{ marginBottom: 10 }}
      />

      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ marginBottom: 20 }}
      >
        <Grid item xs={4}>
          <Skeleton variant="rect" width="100%" height={40} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="rect" width="100%" height={40} />
        </Grid>
      </Grid>

      <Skeleton
        variant="text"
        width={180}
        height={18}
        style={{ marginBottom: 20 }}
      />
      <Grid container spacing={2} style={{ marginBottom: 10 }}>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
      </Grid>

      {[1, 2, 3].map((row) => (
        <Box key={row} mb={3} borderBottom="1px solid #eee">
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="180%" height={25} />
            </Grid>
          </Grid>

          {[1, 2].map((sku) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={sku}
              style={{ marginBottom: 12 }}
            >
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="80%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="50%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="60%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="rect" width={100} height={35} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="rect" width={180} height={40} />
              </Grid>
            </Grid>
          ))}
        </Box>
      ))}

      <Box display="flex" justifyContent="center" mt={4}>
        <Skeleton variant="rect" width={180} height={40} />
      </Box>
    </Box>
  )
}

export const DiscoPromoProductsSkeletonLoader = () => {
  return (
    <Box p={3}>
      <Grid container spacing={2} style={{ marginBottom: 10 }}>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="text" width="90%" height={25} />
        </Grid>
      </Grid>

      {[1, 2, 3].map((row) => (
        <Box key={row} mb={3} borderBottom="1px solid #eee">
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="90%" height={25} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="text" width="180%" height={25} />
            </Grid>
          </Grid>

          {[1, 2].map((sku) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={sku}
              style={{ marginBottom: 12 }}
            >
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="80%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="50%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="60%" height={22} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="rect" width={100} height={35} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="rect" width={180} height={40} />
              </Grid>
            </Grid>
          ))}
        </Box>
      ))}

      <Box display="flex" justifyContent="center" mt={4}>
        <Skeleton variant="rect" width={180} height={40} />
      </Box>
    </Box>
  )
}
